import { render, staticRenderFns } from "./BaseCollapsibleWarning.vue?vue&type=template&id=eb541d3e&scoped=true"
import script from "./BaseCollapsibleWarning.vue?vue&type=script&lang=js"
export * from "./BaseCollapsibleWarning.vue?vue&type=script&lang=js"
import style0 from "./BaseCollapsibleWarning.vue?vue&type=style&index=0&id=eb541d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb541d3e",
  null
  
)

export default component.exports